// components
import { Card, CardsGrid } from '@/components/Card';
import {
  PageSection,
  PageSectionInner,
  PageSectionTitle,
  PageSectionLead,
} from '@/components/PageSection';

export function WhatWeDo({ content }) {
  return (
    <PageSection>
      <PageSectionInner>
        <PageSectionTitle>{content.title}</PageSectionTitle>
        {content.lead && <PageSectionLead>{content.lead}</PageSectionLead>}
        <CardsGrid>
          {content.items.map((item) => (
            <Card key={`what-we-do-${item.title}`} content={item} />
          ))}
        </CardsGrid>
      </PageSectionInner>
    </PageSection>
  );
}
